import { helpSteps } from '@/mocks/chiguaData';

export default function Help() {
  return (
    <section id="help" className="bg-background-100/70 py-16 md:py-24 scroll-mt-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="rounded-[32px] bg-primary-500 overflow-hidden relative">
          <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-primary-400/30 blur-2xl"></div>
          <div className="absolute -left-8 -bottom-12 w-56 h-56 rounded-full bg-primary-600/40 blur-2xl"></div>

          <div className="relative px-6 md:px-12 py-12 md:py-16">
            <div className="max-w-3xl">
              <div className="inline-flex items-center gap-2 text-sm font-semibold text-primary-100">
                <i className="ri-question-line text-lg"></i>打不开 · 找不到入口?
              </div>
              <h2 className="mt-3 font-heading text-3xl md:text-[40px] font-black leading-snug text-background-50">
                三步搞定，吃瓜不断线
              </h2>
              <p className="mt-3 text-background-50/85 text-base md:text-lg leading-relaxed">
                入口打不开不是终点。认准本页三大入口，换线路、看同步、找备用，分分钟重新出发。
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              {helpSteps.map((s) => (
                <div
                  key={s.title}
                  className="rounded-2xl bg-background-50/10 backdrop-blur-sm border border-background-50/20 px-5 py-6"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-11 h-11 rounded-2xl bg-primary-100 text-primary-700 flex items-center justify-center">
                      <i className={`${s.icon} text-xl`}></i>
                    </span>
                    <span className="text-xs font-bold text-primary-100">{s.step}</span>
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-bold text-background-50">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-50/80">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}